import {
  ADMIN_GET_PASSOS_IMPLANTACAO,
  ADMIN_LOAD_PWC,
  ADMIN_LOAD_PWCS,
  ADMIN_LOAD_CONFIG,
  ADMIN_UPDATE_PUBLISH
} from "../actions/admin";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [ADMIN_GET_PASSOS_IMPLANTACAO]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.admin
        .getPassosImplantacao(
          getters.getFornecedorId,
          payload.execute,
          payload.step
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [ADMIN_LOAD_PWC]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.admin
        .listScriptsPWC(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [ADMIN_LOAD_PWCS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.admin
        .listScriptsPWCS(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [ADMIN_LOAD_CONFIG]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.config
        .get(getters.getFornecedorId, payload.dominio, payload.assunto)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [ADMIN_UPDATE_PUBLISH]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.admin
        .updatePublishStatus(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
